<script setup lang="ts">
  import { computed } from 'vue'

  import useBreakpoint from '@/composables/useBreakpoint'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { UserModule } from '@/store/modules/user'

  const { isSmallerMobileDevice } = useBreakpoint()
  const { inDevelopment } = useCommonMixin()

  interface FooterLink {
    href: string
    text: string
  }

  const companyDomainName = computed(() => UserModule.company?.domainName)

  const footerLinks: FooterLink[] = [
    { href: 'https://www.sachkundegurus.de/impressum', text: 'Impressum' },
    { href: 'https://www.sachkundegurus.de/datenschutz', text: 'Datenschutz' },
    { href: 'https://www.sachkundegurus.de/agb', text: 'AGB' },
  ]
</script>

<template lang="pug">
.app-footer-wrapper
  .app-footer.header-spacing
    .top-section
      h5.company-domain-name {{ companyDomainName }}
      .reviews(v-if='!inDevelopment && isSmallerMobileDevice')
        .elfsight-app-ce819a30-419c-4025-b3b1-bcca086d1e71
    nav
      ul
        li(v-for='link in footerLinks', :key='link.href')
          a.h5(:href='link.href', target='_blank') {{ link.text }}
    .reviews(v-if='!inDevelopment')
      .elfsight-app-ce819a30-419c-4025-b3b1-bcca086d1e71
</template>

<style lang="postcss" scoped>
  .app-footer-wrapper {
    @apply ketch-flex ketch-justify-center ketch-items-center ketch-mt-c40;
    @apply ketch-border-border-color sm:ketch-border-t sm:ketch-bg-content-background-color sm:ketch-mt-0;

    .app-footer {
      @apply ketch-flex ketch-flex-col ketch-px-c10 ketch-py-c10 sm:ketch-px-c20;

      .top-section {
        @apply ketch-flex ketch-items-center ketch-justify-between;
      }

      .company-domain-name {
        @apply ketch-font-bold;
      }

      nav {
        ul {
          @apply ketch-flex ketch-items-center ketch-justify-center ketch-space-x-c15 ketch-py-c10;

          li {
            a {
              @apply ketch-transition-colors ketch-duration-200;

              &:hover {
                @apply ketch-text-primary-color;
              }
            }
          }
        }
      }

      @screen xs4 {
        @apply ketch-grid ketch-grid-cols-[1fr_auto_1fr] ketch-items-center;

        .top-section {
          @apply ketch-flex-none;
        }

        nav {
          ul {
            @apply ketch-py-0;
          }
        }

        .reviews {
          @apply ketch-flex ketch-justify-end;
        }
      }
    }
  }
</style>
